import {grayColors} from "../../architecture/gray-colors";

export const baseColors = {
    base01: "#ee3831", //red
    base01Contrast: "#ffffff",
    base01Dark: "#ca2e1e",
    base01Light: "#e94838",

    base02: "#7ff800", //brandGreen
    base02Contrast: "#000000",
    base02Dark: "#7aec37", //inchWorm
    base02Light: "#d2f800", //limeGreen

    base03: "#fce403", //turbo
    base03Contrast: "#000000",
    base03Dark: "#ffff00", //yellow
    base03Light: "#d5ec37", //pear

    base04: "#c81503",

    ...grayColors
};